// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__tsQe8","title":"ClientInsurance_title__2Nz0o","itemText":"ClientInsurance_itemText__3myqs"};